function initAnnouncementBarCarrousel() {

  const swiperEl = document.querySelector(".announcement-bar-section .swiper")
  
  if (swiperEl) {

     const autoplayConfig = swiperEl.getAttribute('data-autoplay') === 'true' ? {
        autoplay: {
          delay: 5000, 
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        }
      } : {};

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        loop: true, 
        ...autoplayConfig,
        navigation: {
            nextEl: document.querySelector(".announcement-bar-section .swiper-button-next"),
            prevEl: document.querySelector(".announcement-bar-section .swiper-button-prev"),
        }
    })
    
  }
}
initAnnouncementBarCarrousel()